import { render } from "./UpdatePersonalDetailsM.vue?vue&type=template&id=b981d428&scoped=true"
import script from "./UpdatePersonalDetailsM.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalDetailsM.vue?vue&type=script&lang=js"

import "./UpdatePersonalDetailsM.vue?vue&type=style&index=0&id=b981d428&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b981d428"]])

export default __exports__